import JSEncrypt from "jsencrypt";

export const encryptText = (text) => {
    const encrypt = new JSEncrypt();
    const publicKey = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAitdV03l4rhz6gk8zEf9DKvYWNWBFybVnub8oUHICqtkvvEjpMiYHngkMCumCsnTF0OvoP76yHeBcPfvsReabmBiZavhy2On//lRwyFH5GwR4UVf+Y3mRXdr+h0pn/D3PamFolKRtR/hDHfuUvYBXPNvYd/qGE78oG2v7+XPnCjA5b2B5IgbxlX7COC5zGL77dmrzolU2rIus6vmyKyidby4OK3e4VmsAumUI2jWnSsijxFnS6wZT78ef9t2UBoMGeSE5+geRwDDQXs19Xt+F8X4FMY6AgvH4eYshguC84gMFy+h4WPLlgMhi30Z46Q8O9cB6M07qBfvi1gOVXiuv6wIDAQAB`
    encrypt.setPublicKey(publicKey);

    return encrypt.encrypt(text) || "";
};
